const DogService = {
  loadImages: async () => {
    const response = await fetch('https://dog.ceo/api/breeds/image/random');
    return await response.json();
  },
  loadGif: async () => {
    const response = await fetch('https://api.giphy.com/v1/gifs/random?api_key=ogPuAVX4Secq4yM6fBl6dL096jHilZx4&tag=dogs&rating=g');
    return await response.json();
  }
}

export default DogService
